
import MemberSidebar from './MemberSidebar'

export default function MemberLayout(props) {
  
  return (
    <>
      <div className="main_container">
      <div className="limani_body">
            <MemberSidebar />
            {props.children}
            </div>
            </div>
        
    </>
  )
}
